import { render, staticRenderFns } from "./zenga-switch.vue?vue&type=template&id=620fd3b4&scoped=true&lang=pug"
import script from "./zenga-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./zenga-switch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./zenga-switch.vue?vue&type=style&index=0&id=620fd3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620fd3b4",
  null
  
)

export default component.exports